// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 此处后端没有提供注释 GET /api/user/info */
export async function userControllerGetUserInfo(options?: {
	[key: string]: any;
}) {
	return request<API.UserInfoResponse>('/api/user/info', {
		method: 'GET',
		...(options || {}),
	});
}

/** 此处后端没有提供注释 POST /api/user/login */
export async function userControllerLogin(
	body: API.UserLoginRequest,
	options?: { [key: string]: any }
) {
	return request<string>('/api/user/login', {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		data: body,
		...(options || {}),
	});
}

/** 此处后端没有提供注释 POST /api/user/password */
export async function userControllerChangeMyPassword(
	body: API.ChangeMyPasswordRequest,
	options?: { [key: string]: any }
) {
	return request<boolean>('/api/user/password', {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		data: body,
		...(options || {}),
	});
}
